import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type Faq = {
  question: string;
  answer: string[];
  bullets?: string[];
};
const faqs: Faq[] = [{
  question: 'How do I receive Salsa & Bachata Instructor Ready after purchasing?',
  answer: ['You receive digital access after your purchase is completed.', 'The package is delivered as PDF resources that can be accessed from compatible devices.']
}, {
  question: 'Is this an app?',
  answer: ['No.', 'Salsa & Bachata Instructor Ready is a digital teaching system delivered in PDF format.']
}, {
  question: 'Does the package contain videos?',
  answer: ['No.', 'The product is a PDF-based visual teaching system.', 'The core material uses visual breakdowns, diagrams, movement sequences, partner positioning, progressions and written instructor guidance.']
}, {
  question: 'Is the material in English?',
  answer: ['Yes.', 'The complete system is provided in English.']
}, {
  question: 'Can I edit the files?',
  answer: ['No.', 'The resources are delivered as finished PDF files.']
}, {
  question: 'Is this only for beginner instructors?',
  answer: ['No.', 'It can support both newer instructors who need structure and experienced instructors who want to reduce planning time and expand their teaching material.']
}, {
  question: 'Is this only for beginner students?',
  answer: ['No.', 'The system includes development from beginner through advanced progression.']
}, {
  question: 'Can I use it if I teach only Salsa?',
  answer: ['Yes.', 'The system contains dedicated Salsa material as well as shared instructor methodology and teaching resources.']
}, {
  question: 'Can I use it if I teach only Bachata?',
  answer: ['Yes.', 'The same applies to Bachata instructors.']
}, {
  question: 'What if I teach both?',
  answer: ['That is where the 6-in-1 system delivers its greatest value: both dance styles and the professional teaching framework are organized together.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-gold/20 bg-mist px-4 py-20 sm:py-28" data-id="element-69" data-mp="2az1yltsejgo0">
      <div className="mx-auto max-w-3xl" data-id="element-70" data-mp="38lrbiyon7don">
        <div className="text-center" data-id="element-71" data-mp="38jeuqoumf9d6">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-72" data-mp="33lwjusx1mk2j">
            FAQ
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-ink sm:text-4xl" data-id="element-73" data-mp="2yma70kl4n5u9">
            Frequently asked <span className="italic text-burgundy" data-id="element-74" data-mp="2umhszscys7hi">questions</span>
          </h2>
        </div>
        <div className="mt-12 space-y-3" data-id="element-75" data-mp="1n8eqp8ihkr1g">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-lg border border-gold/25 bg-white" data-id="element-76" data-mp="1j8nu2o6a3gp0" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 hover:bg-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-burgundy" data-id="element-77" data-mp="2r5jdmltzrij">
                  <span className="text-base font-semibold text-ink" data-id="element-78" data-mp="mcjrw7c6qgpo">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} aria-hidden="true" className={`shrink-0 text-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-79" data-mp="qdvhicv271xv" />
                </button>
                <AnimatePresence initial={false} data-id="element-80" data-mp="2x6o88w713kdd">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-81" data-mp="21uy4el0vwl1s">
                      <div className="space-y-2 border-t border-gold/20 px-6 py-5 text-sm leading-6 text-ink-muted" data-id="element-82" data-mp="26vlxdc8obbyn">
                        {faq.answer.map(paragraph => <p key={paragraph} data-id="element-83" data-mp="1e76mn1wkrft4">{paragraph}</p>)}
                        {faq.bullets && <ul className="list-disc space-y-1 pl-5 marker:text-gold" data-id="element-84" data-mp="1swm8c3h90v1y">
                            {faq.bullets.map(bullet => <li key={bullet} data-id="element-85" data-mp="10eqlk6n8hruu">{bullet}</li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}